import { ElementActionType } from '@agoda/analytics-data-acquisition';
import { useElementAnalytics } from '@agoda/analytics-data-acquisition-react';
import {
    UniversalLoginPinFormElementUniversalLoginFieldsV1,
    UniversalLoginPinFormElementUniversalLoginIdsV1,
    UniversalLoginPinInputElementUniversalLoginFieldsV1,
    UniversalLoginPinInputElementUniversalLoginIdsV1,
    UniversalLoginPinSubmitButtonElementUniversalLoginFieldsV1,
    UniversalLoginPinSubmitButtonElementUniversalLoginIdsV1,
    UniversalLoginForgotPinButtonElementUniversalLoginIdsV1,
    UniversalLoginForgotPinButtonElementUniversalLoginFieldsV1,
} from '@agoda/analytics-messages-definition-universal-login/elements.split';
import {
    UniversalLoginForgotPinButtonElementUniversalLoginManifestV1,
    UniversalLoginPinFormElementUniversalLoginManifestV1,
    UniversalLoginPinInputElementUniversalLoginManifestV1,
    UniversalLoginPinSubmitButtonElementUniversalLoginManifestV1,
} from '@agoda/analytics-messages-definition-universal-login/manifest/elements';

const useAnalytics = () => {
    const AnalyticsPinFormProps = useElementAnalytics<
        UniversalLoginPinFormElementUniversalLoginIdsV1,
        UniversalLoginPinFormElementUniversalLoginFieldsV1
    >([ElementActionType.Seen], UniversalLoginPinFormElementUniversalLoginManifestV1.ids, []);

    const AnalyticsPinInputProps = useElementAnalytics<
        UniversalLoginPinInputElementUniversalLoginIdsV1,
        UniversalLoginPinInputElementUniversalLoginFieldsV1
    >([ElementActionType.Seen], UniversalLoginPinInputElementUniversalLoginManifestV1.ids, []);

    const AnalyticsPinSubmitButtonProps = useElementAnalytics<
        UniversalLoginPinSubmitButtonElementUniversalLoginIdsV1,
        UniversalLoginPinSubmitButtonElementUniversalLoginFieldsV1
    >([ElementActionType.Click], UniversalLoginPinSubmitButtonElementUniversalLoginManifestV1.ids, []);

    const AnalyticsForgotPinProps = useElementAnalytics<
        UniversalLoginForgotPinButtonElementUniversalLoginIdsV1,
        UniversalLoginForgotPinButtonElementUniversalLoginFieldsV1
    >([ElementActionType.Click], UniversalLoginForgotPinButtonElementUniversalLoginManifestV1.ids, []);

    return {
        AnalyticsPinFormProps,
        AnalyticsPinInputProps,
        AnalyticsPinSubmitButtonProps,
        AnalyticsForgotPinProps,
    };
};

export { useAnalytics };
